define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/xml"
], function(declare,Action,xml) {

	return declare(Action, {
		checkNodeAccess: function(/*Node*/node, /*csi.def.Context*/ctx) {
			// summary: ignore PO frozen flag when checking access
			return xml.nodeHasRight(node, this.m_right) && !xml.nodeHasFlag(node, xml.NODE_FLAG_NOEDIT);
		}
	});
});